import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { HistoryRes } from 'shared/types/general.types'
import { AuthContext } from 'store'

export const useFetchAreaTypeHistory = () => {
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const { auth } = useContext(AuthContext)

	const { data: boothTypeHistory, isPending: isLoading } = useQuery<HistoryRes>({
		queryKey: queryKeys.boothTypes.history(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.areaTypeHistory(params.id as string)),
		enabled: !!auth.accessToken
	})

	return {
		boothTypeHistory,
		isLoading
	}
}
